<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">
          <h5
            class="btn-link pointer"
            v-on:click="$goToURL(grantApplication.Grant.URL)"
          >
            {{ grantApplication.Grant.Title }}
          </h5>
          <ul class="nav nav-pills my-4" role="tablist" id="v-pills-tab">
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 7 }"
                v-on:click="changePage(7)"
              >
                Letters of Inqiury
              </button>
            </li>
            <li class="nav-item mr-2">
              <button
                class="btn btn-outline-primary nav-link"
                v-bind:class="{ active: page == 1 }"
                v-on:click="changePage(1)"
              >
                Question / Response
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 2 }"
                v-on:click="changePage(2)"
              >
                Measurable Outcomes
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 3 }"
                v-on:click="changePage(3)"
              >
                Budget
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 4 }"
                v-on:click="changePage(4)"
              >
                Letters of Support
              </button>
            </li>
            <!--<li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 5 }"
                v-on:click="changePage(5)"
              >
                Thank You's
              </button>
            </li>-->
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 6 }"
                v-on:click="changePage(6)"
              >
                Preview / Download
              </button>
            </li>
          </ul>
          <div
            v-if="
              GrantApplication.Grant.Requires_501C3 &&
                $store.getters.user.Account.District_Contacts.some(
                  c => c.District_Contact_Type_Id == 1
                )
            "
            class="text-center"
          >
            <button class="btn btn-link" v-on:click="showContact">
              My 501(c)(3) Contact
            </button>
          </div>
          <ApplicationQuestionResponse
            v-if="page == 1"
            v-bind:GrantApplication="fullGrantApplication"
            @responseCreated="responseCreated"
            @responseRemoved="responseRemoved"
            @blankAnswerCreated="blankAnswerCreated"
            @responseAnswerCreated="responseAnswerCreated"
            @responseAnswerUpdated="responseAnswerUpdated"
          />
          <ApplicationMeasurableOutcomes
            v-if="page == 2"
            v-bind:GrantApplication="fullGrantApplication"
            @responseCreated="responseCreated"
            @responseRemoved="responseRemoved"
            @blankAnswerCreated="blankAnswerCreated"
            @responseAnswerCreated="responseAnswerCreated"
            @responseAnswerUpdated="responseAnswerUpdated"
          />
          <keep-alive>
            <ApplicationBudget
              v-if="page == 3"
              v-bind:GrantApplication="fullGrantApplication"
              @applicationBudget="applicationBudget"
            />
          </keep-alive>
          <ApplicationLettersOfSupport
            v-if="page == 4"
            v-bind:GrantApplication="fullGrantApplication"
            @responseCreated="responseCreated"
            @responseRemoved="responseRemoved"
            @blankAnswerCreated="blankAnswerCreated"
            @responseAnswerCreated="responseAnswerCreated"
            @responseAnswerUpdated="responseAnswerUpdated"
          />
          <ApplicationThankYouLetters
            v-if="page == 5"
            v-bind:GrantApplication="fullGrantApplication"
            @responseCreated="responseCreated"
            @responseRemoved="responseRemoved"
            @blankAnswerCreated="blankAnswerCreated"
            @responseAnswerCreated="responseAnswerCreated"
            @responseAnswerUpdated="responseAnswerUpdated"
          />
          <ReviewApplication
            v-if="page == 6"
            v-bind:Budget="budget"
            v-bind:GrantApplication="fullGrantApplication"
          />
          <ApplicationLettersOfInquiry
            v-if="page == 7"
            v-bind:GrantApplication="fullGrantApplication"
            @responseCreated="responseCreated"
            @responseRemoved="responseRemoved"
            @blankAnswerCreated="blankAnswerCreated"
            @responseAnswerCreated="responseAnswerCreated"
            @responseAnswerUpdated="responseAnswerUpdated"
          />
        </div>
      </div>
    </div>
    <ViewContactModal
      v-bind:Contact="
        $store.getters.user.Account.District_Contacts.find(
          c => c.District_Contact_Type_Id == 1
        )
      "
    />
  </div>
</template>

<script>
import ApplicationQuestionResponse from "@/components/MyGrants/ApplicationQuestionResponse";
import ApplicationLettersOfSupport from "@/components/MyGrants/ApplicationLettersOfSupport";
import ApplicationLettersOfInquiry from "@/components/MyGrants/ApplicationLettersOfInquiry";
import ApplicationMeasurableOutcomes from "@/components/MyGrants/ApplicationMeasurableOutcomes";
import ApplicationThankYouLetters from "@/components/MyGrants/ApplicationThankYouLetters";
import ApplicationBudget from "@/components/MyGrants/ApplicationBudget";
import ReviewApplication from "@/components/MyGrants/ReviewApplication";
import ViewContactModal from "@/modals/ManageGrants/ViewContactModal";
import $ from "jquery";

export default {
  name: "MyGrants",
  components: {
    ApplicationQuestionResponse,
    ApplicationLettersOfSupport,
    ApplicationMeasurableOutcomes,
    ApplicationThankYouLetters,
    ApplicationBudget,
    ReviewApplication,
    ViewContactModal,
    ApplicationLettersOfInquiry
  },
  props: {
    GrantApplication: Object
  },
  data() {
    return {
      page: 1,
      grantApplication: this.GrantApplication,
      fullGrantApplication: { Grant_Application_Budget: {} },
      budget: null
    };
  },
  async mounted() {
    await this.$getGrantApplication(
      this.grantApplication.Grant_Application_Id
    ).then(grantApplication => {
      this.fullGrantApplication = Object.assign(
        {},
        this.grantApplication,
        grantApplication
      );
      this.budget = this.fullGrantApplication.Grant_Application_Budget;
    });
  },
  methods: {
    changePage(num) {
      this.page = num;
    },
    responseCreated(response) {
      this.fullGrantApplication.Grant_Application_Responses.push(response);
    },
    responseRemoved(response) {
      this.fullGrantApplication.Grant_Application_Responses = this.fullGrantApplication.Grant_Application_Responses.filter(
        r =>
          r.Grant_Application_Response_Id !=
          response.Grant_Application_Response_Id
      );
    },
    blankAnswerCreated(newBlankAnswer, responseId) {
      var responseIndex = this.fullGrantApplication.Grant_Application_Responses.findIndex(
        r => r.Grant_Application_Response_Id == responseId
      );
      this.fullGrantApplication.Grant_Application_Responses[
        responseIndex
      ].Application_Template_Response.Template_Response_Blank_Answers.push(
        newBlankAnswer
      );
    },
    responseAnswerCreated(newResponseAnswer, responseId) {
      var responseIndex = this.fullGrantApplication.Grant_Application_Responses.findIndex(
        r => r.Grant_Application_Response_Id == responseId
      );
      this.fullGrantApplication.Grant_Application_Responses[
        responseIndex
      ].Grant_Application_Response_Answers.push(newResponseAnswer);
    },
    responseAnswerUpdated(updatedResponseAnswer, responseId) {
      var responseIndex = this.responsesToShow.findIndex(
        r => r.Grant_Application_Response_Id == responseId
      );
      var responseToUpdate = this.fullGrantApplication
        .Grant_Application_Responses[responseIndex];
      var responseAnswerIndex = responseToUpdate.Grant_Application_Response_Answers.findIndex(
        a =>
          a.Grant_Application_Response_Answer_Id ==
          updatedResponseAnswer.Grant_Application_Response_Answer_Id
      );
      responseToUpdate.Grant_Application_Response_Answers[
        responseAnswerIndex
      ] = updatedResponseAnswer;
      this.$set(
        this.fullGrantApplication.Grant_Application_Responses,
        responseIndex,
        responseToUpdate
      );
    },
    applicationBudget(budget) {
      budget.Budget = JSON.stringify(budget.Budget);
      this.fullGrantApplication.Grant_Application_Budget = budget;
      this.budget = budget;
    },
    showContact() {
      $("#viewContactModal").modal("show");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
